export default "__VITE_ASSET__Cg5IXv9O__"